import Label from "lib/Label";
import { Image } from "lib";
import show_password from "assets/images/show_password.svg";
import hide_password from "assets/images/hide_password.svg";
import "./index.scss";
import ErrorMessage from "lib/ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { setIsKeyDuplicate } from "redux/recursiveReducer";
import { verifyDocumentNumber,generatePinCodeDeatils,getDuplicateData } from "api/formDisplay";
import Toast from "components/ToastComponent";
import InviteCustomer from "components/InviteCustomer";
import { ClearResponses, setVerificationResponse } from "redux/uploadDocumentReducer";
import { setIsDuplicateFormInput } from "redux/formDisplay";
import { getRecordsByQuery } from "api/uae-pass";


const VerifyInput = (props) => {
  const dispatch = useDispatch();
  const {
    tooltip,
    placeholder,
    label,
    value,
    onChange,
    default_value,
    onLoad,
    disabled,
    type,
    name,
    size,
    error,
    events,
    doc_type,
    isEditable,
    selectedData = {},
    is_disabled,
    validators,
    action_button_name,
    setSelectedData,
    action_button_loading_text,
    verify,
    autofill,
    verification_id,
    masking_type,
    error_messages,
    otp_verification_details,
    id,
    substring_exprn,
    validate_duplication,
    validate_duplication_type,
    validate_duplication_by,
    action_button_sucess_text
  } = props;

  const verificationResponses = useSelector(
    (state) => state.uploadDocumentReducer.uploadVerificationResponses
  );
  let previousNumberExtarctioResponse = verificationResponses[verification_id];
  const IndirectEval = (evalString) => {
    return eval(evalString);
  };
  const [newType, setType] = useState(type);
  const [messageToast, setMessageToast] = useState({ type: "", msg: "" });
  const errActive = error && error?.length !== 0;
  const errorClass = errActive ? "error_outline" : "";
  const [isUploading, setIsUploading] = useState(false);
  const [isSucess, setIsSucess] = useState(false);

  const [previousdocumentnumber, setpreviousdocumentnumber] = useState(false);
  const isToggled = useSelector((state) => state.formData.isToggled);
  const copiedData = useSelector((state) => state.formData.copiedData);
  const subworkflows = useSelector(
    (state) => state.userInfo.workflowUser.subworkflows
  );
  const otpReducer = useSelector((state)=> state?.otpReducer)
  const aadhaarVerificationResponse = useSelector((state)=>state.otpReducer.otpResponse.aadhaar_otp)
  const organisation_id = useSelector(( state) => state.configurationReducer?.config)?.organisation_id
  const isDuplicateFormInput = useSelector((state) => state.formData.isDuplicateFormInput);
  const recursiveFormData = useSelector((state) => state.recursive?.recursiveFormData);
  const configurationId = useSelector((state) => state.conditionalRendering?.configurationId);
  const workflow_id = subworkflows?._id;
  const [verified,setVerification] = useState(false)
  // const dispatch = useDispatch();
  const [showPopUp,setValueToShowPopup] = useState(false)
  const [uniqueDataError, setUniqueDataError] = useState(false);
  let res;
  
  const checkDuplicate = async (data) => {
    let response;
    response = await (getDuplicateData(data));
    if(response?.data.length == 1 && response?.data[0]._id == workflow_id ){
      dispatch(setIsDuplicateFormInput({ [name]: false }));
      dispatch(setSelectedData({key : [`${name}_duplicated`], value : false  }));
    }
   else if (response.status.toLowerCase() == 'success' && !!response?.data.length) {
      dispatch(setIsDuplicateFormInput({ [name]: true }));
      dispatch(setSelectedData({key :  [`${name}_duplicated`], value : true }));
    }
    else if (response.status.toLowerCase() == 'success' && response?.data.length == 0) {
      dispatch(setSelectedData({  key : [`${name}_duplicated`], value : false }));
      dispatch(setIsDuplicateFormInput({ [name]: false }) );
    }
  }

  const onKeyUpCapture = async (event) => {
    let payload = {}, res;
    if (validate_duplication_by == 'organisation') {
    
      payload = {
        [`source_data.${name}`]: selectedData[name],
        organisation_id,
        workflow_id,
        name
      }
    } else {
      payload = {
        [`source_data.${name}`]: selectedData[name],
        configuration_id: configurationId,
        name
      }
    }
    if (validate_duplication) {
      res =  await checkDuplicate(payload);
    }

    if(res?.data?.length == 0 || !validate_duplication){
      if (events) {
        IndirectEval(events?.onKeyUpCapture);
      }
      let document_number = selectedData[name];
      let previous_document_number;
      let pattern = validators.pattern[0];
      var regex_pattern = new RegExp(pattern);
      if (
        !document_number?.length > 0 ||
        Number(validators.min_length) > document_number.length
      ) {
        showToast("error", error_messages?.min_error ? `${error_messages?.min_error}` : `Invalid Length.Enter Minimum ${validators.min_length} Digit Number`);
      } else if (Number(validators.max_length) < document_number.length) {
        showToast(
          "error",
          `${error_messages?.max_error}`
        );
        showToast("error", error_messages?.max_error ? `${error_messages?.max_error}` : `Invalid Length.Enter Maxmum ${validators.max_length} Digit Number`);
  
      } else if (!regex_pattern.test(document_number)) {
        showToast("error", error_messages?.pattern_error ? `${error_messages?.pattern_error}` : `Pattern mismatch`);
  
      } else if (verification_id === 'aadhaar_xml') {
        setValueToShowPopup(true);
      }else if(verification_id === 'pin_code'){
        await pinCodeDetailsExtraction(document_number, doc_type)
      }
      else {
        if (previousNumberExtarctioResponse?.data) {
          if (previousNumberExtarctioResponse?.data?.pan_number?.toUpperCase() === document_number.toUpperCase() || previousNumberExtarctioResponse?.data?.license_number?.toUpperCase() === document_number.toUpperCase() || previousNumberExtarctioResponse?.data?.epic_no?.toUpperCase() === document_number.toUpperCase()||previousNumberExtarctioResponse?.data?.gstin?.toUpperCase() === document_number.toUpperCase() ) {
            showToast("success", "Number already verified");
          } else
            if (previousNumberExtarctioResponse?.data?.cin?.toUpperCase() === document_number.toUpperCase()){
              const errorMessage = "Same as last CIN entered";
              setMessageToast({ type: "error", msg: errorMessage });
              setTimeout(() => {
                setMessageToast(null);
              }, 3000);
            }else if(previous_document_number === document_number) {
              const errorMessage = "Current document number cannot be the same as the previous one.";
              setMessageToast({ type: "error", msg: errorMessage });
              setTimeout(() => {
                setMessageToast(null);
              }, 2000);
            } else {
              await docNumberExtraction(document_number, doc_type);
            }
        } else if(verification_id === "uae_pass_email"){
          setIsUploading(true)
          const email = selectedData?.validate_email;
          const query = { "source_data.subworkflows.email": email };
          const response = await getRecordsByQuery({ query });
          console.log("🚀 ~ onKeyUpCapture ~ response:", response)
          if (response?.status === "success" && response.data) {
            setIsSucess(true)
            dispatch(setSelectedData({ key: "Proceed_as_new", value: false }));
            dispatch(setSelectedData(email));
            dispatch(setSelectedData({ key: "valid_email", value: true }));
          } else if (response?.status === "failed") {
             setIsUploading(false)
            dispatch(setSelectedData({ key: "Proceed_as_new", value: true }));
            dispatch(setSelectedData({ key: "valid_email", value: false }));
          }
          // setIsUploading(false)
          return;
        }
        else {
            
            await docNumberExtraction(document_number, doc_type);
            
        }
        
    }

   
      // await docNumberExtraction(document_number, doc_type);
    

    function showToast(type, message) {
      setMessageToast({ type: type, msg: message });
      setTimeout(() => {
        setMessageToast(null);
      }, 2000);
    }
  }
  };

  const closeModal = () => {
    setValueToShowPopup(false)
  };

  useEffect(() => {
    if (default_value && disabled) {
      onLoad(name, default_value);
    }
  }, [disabled]);

  useEffect(() => {
    if (masking_type) {
      setType(masking_type);
    }
  }, [masking_type]);

  const togglePassword = () => {
    if (newType == masking_type) {
      setType("text");
      return;
    }
    setType(masking_type);
  };
  const pinCodeDetailsExtraction = async(data,docType)=>{
    if (previousdocumentnumber === data) {
      const errorMessage = "Already Verfied";
      setMessageToast({ type: "success", msg: errorMessage });
      setTimeout(() => {
        setMessageToast(null);
      }, 2000);
    } else{
      let result;
      autofill?.forEach((item) => {
        dispatch(
          setSelectedData({
            key: [`${item?.destination_field}`],
            value: "",
          })
        );
      });
      setIsUploading(true);
      result = await generatePinCodeDeatils({
        data,
        docType,
        verify,
        selectedData,
        verification_id,
        id,
        subworkflows
      });
      if(result.status =='success'){
        autofill?.forEach((item) => {
          dispatch(
            setSelectedData({
              key: [`${item?.destination_field}`],
              value: eval(`result?.data?.${item?.source_field}`),
            })
            );
        });
        const message = result?.message
        ? result?.message
        : "Document Number extracted successfully";
      setMessageToast({ type: "success", msg: message });
      }else{
        setMessageToast({ type: "error", msg: result.message });
        setTimeout(() => {
          setMessageToast(null);
        }, 2000);
      }
      setIsUploading(false);
      setpreviousdocumentnumber(data);
    }



  }
  const docNumberExtraction = async (data, docType) => {
     
      let result;
      setIsUploading(true);
      let dob = subworkflows?.birth_date;
      dob = dob?.split("/").reverse().join("-");
      autofill?.forEach((item) => {
        dispatch(
          setSelectedData({
            key: [`${item?.destination_field}`],
            value: "",
          })
        );
      });
      let state = subworkflows?.shop_establishment_state;
      result = await verifyDocumentNumber({
        data,
        docType,
        verify,
        dob,
        selectedData,
        verification_id,
        subworkflows,
        state,
        substring_exprn
      });
      if (result?.status === "success") {
        dispatch(
          setVerificationResponse({
            key: verification_id,
            value: result || result?.data || result?.data[0],
          })
        );
        autofill?.forEach((item) => {
          dispatch(
            setSelectedData({
              key: [`${item?.destination_field}`],
              value: eval(`result?.data?.${item?.source_field}`) || eval(`result?.data[0]?.${item?.source_field}`),
            })
            );
        });
        const message = result?.message
          ? result?.message
          : "Document Number extracted successfully";
        setMessageToast({ type: "success", msg: message });
        setTimeout(() => {
          setMessageToast(null);
        }, 2000);
        setIsUploading(false);
      } else {
        setIsUploading(false);
        const errorMessage = result?.message
          ? result?.message
          : "Invalid Number, Please enter a valid file";
        setMessageToast({ type: "error", msg: errorMessage });
        setTimeout(() => {
          setMessageToast(null);
        }, 2000);
        dispatch(ClearResponses());
      }
      let previousdocumentnumber = data;
      setpreviousdocumentnumber(data);
   
      
   
    
  };
  useEffect(() => {
    dispatch(setIsKeyDuplicate(uniqueDataError));
  }, [uniqueDataError]);

  const handleInputChange = () => {
    dispatch(
      setIsDuplicateFormInput({ [name]: false })
    );
  }

  return (
    <div className={size}>
      {messageToast?.msg && (
        <Toast message={messageToast?.msg} type={messageToast?.type} />
      )}
      {label ? (
        <Label label={label} tooltip={tooltip} validators={validators} />
      ) : (
        <div className="mt-2" />
      )}
      {!isUploading ? (
        <div className="verify-div">
          <div className=" verify-input position-relative">
            <input
              type={newType}
              name={name}
              className={`form-input  ${
                uniqueDataError ? "duplicate_error" : ""
              } ${!isEditable && "radioDisabled"} ${errorClass}`}
              placeholder={placeholder}
              value={value || ""}
              disabled={
                (is_disabled && eval(is_disabled))
                  ? true
                  : !isEditable ||
                    (isToggled && copiedData?.[name] !== undefined) ||
                    (disabled && IndirectEval(disabled))
              }
              onChange={onChange}
              onKeyDownCapture={handleInputChange}  
            />
             {uniqueDataError ? <span className='duplicate_code_error'>{label} should be unique</span> : null} 
            {isDuplicateFormInput[name] == true && (selectedData[name]?.length > 0) ? <span className='duplicate_code_error'>{error_messages?.duplicate_error}</span> : null}
            {error?.length !== 0 && <ErrorMessage error={error} />}
            {masking_type ? (
              <Image
                className="img_container  position-absolute"
                imageSrc={newType == "password" ? show_password : hide_password}
                onClick={togglePassword}
              />
            ) : (
              ""
            )}
          </div>
          <button
            className="verifybutton"
            onClick={onKeyUpCapture}
            // disabled={isDuplicateFormInput && !!Object.keys(isDuplicateFormInput).length}
            // size={"col-lg-9 col-md-9 col-sm-9"}
          >
            <b>{action_button_name ? action_button_name : 'Verify'}</b>
          </button>
        </div>
      ) : isUploading && isSucess ? (
        <div className="verify-div">
        <div className="verify-input position-relative">
          <input
            value={value}
            type={type}
            name={name}
            className={`form-input`}
            placeholder={placeholder}
            disabled={true}
      
          />
        </div>
        <div className="position-relative">
          <button
            className="verifybutton d-flex justify-content-around px-2"
            onClick={onKeyUpCapture}
          >
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
<g id="Group_55455" data-name="Group 55455" transform="translate(-409.689 -30.133)">
  <circle id="Ellipse_2147" data-name="Ellipse 2147" cx="8" cy="8" r="8" transform="translate(409.689 30.133)" fill="#62a159"/>
  <path id="Icon_feather-check" data-name="Icon feather-check" d="M12.558,9,8.049,13.508,6,11.459" transform="translate(408.731 27.289)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
</g>
</svg>
            <p className="fw-bold mb-0 mt-2"> {action_button_sucess_text?action_button_sucess_text:'Verified'}</p>
          </button>


          {/* <div class="spin-loader-btn  position-absolute"></div> */}
        </div>
        
      </div>
      ):(
        <div className="verify-div">
          <div className="verify-input position-relative">
            <input
              value={value}
              type={type}
              name={name}
              className={`form-input`}
              placeholder={placeholder}
              disabled={true}
        
            />
          </div>
          <div className="position-relative">
            <button
              className="verifybutton"
              onClick={onKeyUpCapture}
              style={{  paddingLeft: "15px"
              
              }}
            >
              <b> {action_button_loading_text?action_button_loading_text:'Verifying..'}</b>
            </button>
            <div class="spin-loader-btn  position-absolute"></div>
          </div>
        </div>
      )}
      {showPopUp && (
        <InviteCustomer
          showModal={showPopUp}
          closeModal={closeModal}
          otp_verification_details = {otp_verification_details}
          model_name = {"Verification"}
          fieldName = {id}
          selectedData = {selectedData}
          autofill = {autofill}
        />
      )}
    </div>
  );
};

export default VerifyInput;
